import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CheckBox from '../../CheckBox';
import SecondaryButton from '../../SecondaryButton';
import { PreviewSection, ContentWrapper, ChecklistWrapper, ChecklistHeader, ChecklistBody } from '../styles';
import { PreviewText, ButtonWrapper } from '../../NodeActivityEditor/styles';

const ChecklistContentPreview = ({ data, previewText }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(
      [...(data.ChecklistItems || [])]
        .sort((a, b) => a.order - b.order)
        .map((item) => {
          const { id, content, order } = item;
          return {
            id,
            content,
            order,
            checked: false,
          };
        }),
    );
  }, [data]);

  const list = items.map((item, index) => {
    return (
      <CheckBox
        key={index}
        id={`${item.id}`}
        text={item.content}
        defaultChecked={item.checked}
        onChange={() => {
          item.checked = !item.checked;
        }}
        value={1}
        lightMode={true}
      />
    );
  });

  return (
    <PreviewSection>
      <ContentWrapper>
        <ChecklistWrapper>
          <ChecklistHeader>
            <h2>{i18n.__('checklists.header')}</h2>
          </ChecklistHeader>
          <ChecklistBody>{list}</ChecklistBody>
        </ChecklistWrapper>
      </ContentWrapper>
      {previewText && <PreviewText dangerouslySetInnerHTML={{ __html: previewText }} />}
      <ButtonWrapper className={'ir-hide'}>
        <SecondaryButton disabled={true} text={i18n.__('app_handin')} />
      </ButtonWrapper>
    </PreviewSection>
  );
};

export default ChecklistContentPreview;

ChecklistContentPreview.propTypes = {
  data: PropTypes.object.isRequired,
  previewText: PropTypes.string.isRequired,
};
